import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { Route as rootRoute } from "./__root";

// El contenido real vive en clases-calistenia-nunoa-page.tsx y se descarga aparte (code-split) —
// así visitar el home u otra página pública no baja el bundle de esta (ver mismo criterio en
// staff.tsx).
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/clases-calistenia-nunoa",
  head: () => ({
    meta: seoMeta({
      title: "Clases de Calistenia en Ñuñoa | Calistenia Progresiva",
      description: "Clases grupales de calistenia en Ñuñoa, en el Parque Juan Moya Morales (Limache 1240). Horarios, profesores y cómo llegar. Agenda tu primera clase.",
      path: "/clases-calistenia-nunoa",
    }),
    links: [canonicalLink("/clases-calistenia-nunoa")],
  }),
  component: lazyRouteComponent(() => import("./clases-calistenia-nunoa-page"), "SedeNunoaPage"),
});
